var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aiInfoTable',{ref:"table",attrs:{"aiHeaders":_vm.aiHeaders,"apiUrl":"/v2/ai/get-all-features","editable":false,"clientId":_vm.clientId,"filters":_vm.filters,"hide-header":true,"data-testid":"ai-features-tab"}})
}
var staticRenderFns = []

export { render, staticRenderFns }